import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { eCommodityTypes } from '../../../../interfaces/constants';
import { ICommodityTypeDialogInput, ICommodityTypeFormResult } from '../../../../models/commodity-type/interfaces';
import { CommodityService } from '../../../../models/commodity-type/service';
import { CASPNotNowCookieName } from '../../../../services/constants';
import { CookieService } from '../../../../services/cookie.service';
import { UpdateService } from '../../../../services/update.service';
import { CaspDialogComponent } from '../../../casp-dialog/casp-dialog';
import { CaspService } from '../../../casp-dialog/casp.service';
import { DIALOG_HIDE_CLASS } from '../../../shared/constants';
import { eRanchSettingNames } from '../../interfaces';
import { RanchCommodityTypeFormComponent } from '../../shared/ranch-commodity-type-form/main';

@Component({
	moduleId: module.id,
	selector: 'commodity-type-create-dialog',
	templateUrl: 'create.html',
	styleUrls: ['create.scss']
})

export class CommodityTypeCreateDialog implements OnInit, OnDestroy {
	public isSaving: boolean;
	public ranchGuid: string;

	@ViewChild(RanchCommodityTypeFormComponent, { static: false })
	public commodityTypeForm: RanchCommodityTypeFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		private _dialog: MatDialog,
		public dialogRef: MatDialogRef<CommodityTypeCreateDialog>,
		@Inject(MAT_DIALOG_DATA) public data: ICommodityTypeDialogInput,
		private _commodityService: CommodityService,
		private _updateService: UpdateService,
		private _caspService: CaspService
	) {
		this._subscriptions$ = new Subject();
		this.ranchGuid = data.ranchGuid;

		this.dialogRef.disableClose = true;
		this.dialogRef.backdropClick().pipe(takeUntil(this._subscriptions$)).subscribe(() => {
			this.close();
		});
	}

	public ngOnInit(): void {
		this.isSaving = false;
	}

	public ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public close(): void {
		if (!this.commodityTypeForm) {
			this.closeFinal();
			return;
		}

		this.commodityTypeForm.cancel();
	}

	public closeFinal(): void {
		this.dialogRef.close();
	}

	public hide(): void {
		this.dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public save(result: ICommodityTypeFormResult): void {
		if (this.isSaving) {
			return;
		}

		this.isSaving = true;

		this._commodityService.saveByRanch(this.ranchGuid, result.CommodityTypeId,
			result.CropTypeIds).then(() => {
				this.isSaving = false;

				this._updateService.setRanchSettingsUpdated(
					eRanchSettingNames.commodityTypes);

				this.dialogRef.close();

				this._openCaspDialog(result.CommodityTypeId);
			});
	}

	public show(): void {
		this.dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}

	private _openCaspDialog(commodityTypeId: number): void {
		if (commodityTypeId !== eCommodityTypes.ALMOND) {
			return;
		}

		if (CookieService.get(CASPNotNowCookieName)) {
			return;
		}

		this._caspService.shouldPrompt(this._updateService.currentRanchId).then(response => {
			if (response === false) {
				return;
			}

			this._dialog.open(CaspDialogComponent, {
				disableClose: false,
				width: '800px',
				data: {
				}
			});
		});
	}
}
